/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021-2022, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

/**
 * @module bulb-image-carousel/bulbimagecarouselcommand
 * */

import { Command, type ModelWriter, type ModelElement } from 'ckeditor5';

/**
 * The bulb image carousel command, the actual insert capabilities of the plugin.
 *
 * @extends Command
 */
export class InsertBulbImageCarouselCommand extends Command {

  /**
   * Executes the command to insert a new image carousel block.
   *
   * @param blockDetails - The block details to insert.
   * @param insertPosition - The position to insert the block
   *
   */
  public override execute(blockDetails: any, insertPosition: any): void {
    this.editor.model.change((writer: ModelWriter) => {
      // Insert Image carousel block.
      this.editor.model.insertContent(this.createImageCarouselBlock(writer, blockDetails), insertPosition);
      CKEBulbData.service.ckeStateService.insertParagraphSubject.next(true);
    });
  }

  public override refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;
    const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'imageCarousel');

    this.isEnabled = allowedIn !== null;
  }

  private createImageCarouselBlock(writer: ModelWriter, blockDetails: any): ModelElement {
    return writer.createElement('imageCarousel', {
      'bulb-block-id': blockDetails.id,
      'bulb-block-version': blockDetails.version,
    });
  }
}
